import { render, staticRenderFns } from "./dataWarn.vue?vue&type=template&id=9b84492a&"
import script from "./dataWarn.vue?vue&type=script&lang=js&"
export * from "./dataWarn.vue?vue&type=script&lang=js&"
import style0 from "./dataWarn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports